<template>
  <span>
  <b-menu-item :class="{'sidebar-menu-item-with-extra-text': !!extraText}"
               :extratext.prop="extraText"
               :icon="icon"
               :tag="tag"
               :title="title"
               :to="to"
               :label="label"/>
    <span v-if="!!extraText"
          class="has-text-grey is-italic">{{ extraText }}</span>
  </span>
</template>

<script>
export default {
  name: 'SideBarExtendedMenuItem',
  props: {
    icon: {
      type: String,
      default: '',
    },
    tag: {
      type: String,
      default: 'router-link',
    },
    title: {
      type: String,
      required: true,
    },
    to: {
      type: [String, Object],
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    extraText: {
      type: [String, Boolean],
      default: false,
    },
  },
}
</script>

<style scoped>
.sidebar-menu-item-with-extra-text {
  color: red !important;
  display: flex;
  justify-content: space-between;
}

.sidebar-menu-item-with-extra-text::after {
  content: attr(extratext);
  color: green;
}
</style>
